module.exports = __webpack_public_path__ + "img/icon-app-tor.2cb9c59b.svg";